import { httpClient } from '@/http/client';
import { VerifyAccountRequestBody } from 'bff';
import { TENANT_SLUG_HEADER_KEY } from 'piramid-constants';

export const verifyAccount = async ({
  body,
}: {
  body: VerifyAccountRequestBody;
}) => await httpClient.put(body, '/v1/auth/verification/verify').json();
